import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import FunctionalErrorBoundary from "./common/component/error-boundry/FunctionalErrorBoundry.js";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import { AuthProvider } from "./utlis/authContext.js";


// Lazy load the AppRoutes component
const LazyAppRoutes = React.lazy(() => import("./routes/AppRoutes.js"));

const App = () => {
  return (
    <Provider store={store}>{/* ✅ Wrap the app with Redux Provider */}
      <AuthProvider>
        <FunctionalErrorBoundary>
          <Router>
            <Suspense fallback={<CircularProgress color="primary" style={{ margin: "auto", display: "block" }} />}>
              <LazyAppRoutes />
            </Suspense>
          </Router>
        </FunctionalErrorBoundary>
      </AuthProvider>
    </Provider>

  );
};

export default App;
